export default __webpack_public_path__ + "static/media/ax.6a699df6.jpg";